// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1___9513dde4b3ab9bdcc00","cls2":"ResearchInterestTags-cls2__cdb78753dd1d92acd47a ResearchInterestTags-cls1___9513dde4b3ab9bdcc00"};